import { Icon } from '@dixa/lib-shared-habla';
import { useEffect, useRef } from 'react';

import {
  useOrderedDragDrop,
  type UseOrderedDragDropOptions,
} from 'utils/useOrderedDragDrop';

import { useSidebarMode } from '../../hooks/useSidebarMode';

import styles from './cardMoveHandle.module.scss';

type CardMoveHandleProps = Pick<
  UseOrderedDragDropOptions,
  'type' | 'index' | 'onMove' | 'target'
>;

// Hidden cards stay reorderable (matching the admin settings page, where
// "always hide" rows are still draggable); they're only dimmed by the
// surrounding wrapper.
export const CardMoveHandle = ({
  index,
  type,
  onMove,
  target,
}: CardMoveHandleProps): JSX.Element | null => {
  const rowHandle = useRef<HTMLDivElement>(null);
  const { isOver } = useOrderedDragDrop({
    type,
    index,
    source: rowHandle,
    target,
    preview: target,
    onMove,
    triggerSwap: 'drop',
  });

  useEffect(() => {
    target.current?.classList.toggle(styles.isOver, isOver);
  }, [isOver, target]);

  if (useSidebarMode() !== 'customization') {
    return null;
  }

  return (
    <div ref={rowHandle} className={styles.handle}>
      <Icon name="bars" />
    </div>
  );
};
